import AddTerritoryModal from "./AddTerritoryModal";
import DeleteTerritoryModal from "./DeleteTerritoryModal";

export const MODALS = {
  addTerritoryModal: AddTerritoryModal,
  deleteTerritoryModal: DeleteTerritoryModal,
};
